function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useMemo, useRef } from 'react';
import { Modal, Fade } from '@material-ui/core';
import cn from 'classnames';
import { BiModalContainer } from "../BiTracking";
import styles from "./OverlayContext.module.scss";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getTransitionDuration = isTestMode => isTestMode ? 0 : 225;
const DefaultModalWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
const makeModalCustomBackdrop = isTestMode => {
  return _ref2 => {
    let {
      open,
      onClick,
      modal
    } = _ref2;
    const FadeComp = Fade;
    return /*#__PURE__*/_jsx(FadeComp, {
      timeout: getTransitionDuration(isTestMode),
      in: open,
      onClick: onClick,
      children: /*#__PURE__*/_jsx("div", {
        className: cn(styles.modalBackdrop, {
          [styles.modalBg]: !modal.transparentBackdrop
        })
      })
    });
  };
};
export function ModalContainer(_ref3) {
  let {
    modal,
    ModalWrapper = DefaultModalWrapper,
    isTestMode,
    disableEnforceFocus,
    triggerClose,
    onModalExited
  } = _ref3;
  const [returnValue, setReturnValue] = useState(undefined);
  const canDismissModal = useRef();
  const registerCanDismiss = cb => canDismissModal.current = cb;
  const BackdropComponent = useMemo(() => makeModalCustomBackdrop(isTestMode), [isTestMode]);
  const dismissModal = async function dismissModal(value) {
    let {
      force
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (canDismissModal.current && !force) {
      const confirmed = await canDismissModal.current();
      if (!confirmed) return;
    }
    setReturnValue(value);
    triggerClose(modal.id);
  };
  modal.dismissModal = dismissModal;
  const modalProps = {
    dismissModal,
    registerCanDismiss
  };
  return /*#__PURE__*/_jsx(Modal, {
    open: modal.isOpen,
    disableEnforceFocus: disableEnforceFocus || modal.disableEnforceFocus,
    closeAfterTransition: true,
    BackdropComponent: BackdropComponent,
    BackdropProps: {
      modal
    },
    onClose: (e, reason) => {
      if (reason === 'escapeKeyDown' && modal.closeOnEscapeKey) {
        dismissModal();
      }
    },
    children: /*#__PURE__*/_jsx(Fade, {
      timeout: getTransitionDuration(isTestMode),
      in: modal.isOpen,
      onExited: () => {
        modal.resolve(returnValue);
        onModalExited(modal.id);
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.modalContainer,
        style: _objectSpread(_objectSpread({}, modal.theme), {}, {
          pointerEvents: modal.isOpen ? 'auto' : 'none'
        }),
        "data-testid": "modal-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.modalBackdrop,
          "data-testid": "modal-backdrop",
          onClick: () => {
            if (modal.closeOnClickOutside) {
              dismissModal();
            }
          }
        }), /*#__PURE__*/_jsx(BiModalContainer, {
          biName: modal.biName,
          biData: modal.biData,
          biCallerContext: modal.biCallerContext,
          children: /*#__PURE__*/_jsx(ModalWrapper, _objectSpread(_objectSpread({}, modalProps), {}, {
            children: modal.content && (typeof modal.content === 'function' ? modal.content(modalProps) : /*#__PURE__*/React.cloneElement(modal.content, modalProps))
          }))
        })]
      })
    })
  });
}